const MentionsLegales = () => {
  return (
    <section className="section-padding bg-background">
      <div className="max-w-3xl mx-auto prose prose-sm">
        <h1 className="font-heading text-3xl font-bold text-foreground">Mentions légales</h1>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">1. Éditeur du site</h2>
        <p className="text-muted-foreground font-body">
          Le site internet bodybycc.fr est édité par <strong className="text-foreground">Body by CC</strong>, institut de beauté et bien-être, situé au 65 Boulevard Westinghouse, 93270 Sevran, France.
        </p>
        <ul className="text-muted-foreground list-disc pl-6 space-y-1 font-body">
          <li>Responsable de la publication : Carine Tchuente</li>
          <li>Email : <a href="mailto:kreent@yahoo.fr" className="text-primary hover:underline">kreent@yahoo.fr</a></li>
          <li>Téléphone : <a href="tel:+33645230034" className="text-primary hover:underline">06 45 23 00 34</a></li>
        </ul>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">2. Hébergement du site</h2>
        <p className="text-muted-foreground font-body">
          Le site est hébergé par OVH, SAS au capital de 10 174 560 €, siège social : 2 rue Kellermann, 59100 Roubaix, France. Téléphone : +33 (0)9 72 10 10 07. Site web : <a href="https://www.ovh.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">www.ovh.com</a>
        </p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">3. Objet du site</h2>
        <p className="text-muted-foreground font-body">Présentation des activités et services de Body by CC, institut de beauté et bien-être à Sevran.</p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">4. Propriété intellectuelle</h2>
        <p className="text-muted-foreground font-body">Tous les éléments du site (textes, images, logos, vidéos, etc.) sont la propriété exclusive de Body by CC. Toute reproduction ou exploitation non autorisée est interdite.</p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">5. Données personnelles et cookies</h2>
        <p className="text-muted-foreground font-body">
          Des cookies peuvent être installés automatiquement. L'utilisateur peut les accepter, refuser ou paramétrer via son navigateur. Conformément à la loi Informatique et Libertés et au RGPD, l'utilisateur dispose d'un droit d'accès, de rectification et de suppression de ses données personnelles : <a href="mailto:kreent@yahoo.fr" className="text-primary hover:underline">kreent@yahoo.fr</a>
        </p>
        <p className="text-muted-foreground font-body">
          Pour plus d'informations, consultez notre <a href="/politique-de-confidentialite" className="text-primary hover:underline">Politique de confidentialité</a>.
        </p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">6. Responsabilité</h2>
        <p className="text-muted-foreground font-body">Body by CC ne peut être tenue responsable d'erreurs, omissions ou indisponibilités temporaires du site.</p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">7. Médiation à la consommation</h2>
        <p className="text-muted-foreground font-body">
          Recours gratuit à un médiateur disponible sur : <a href="https://www.economie.gouv.fr/mediation-conso" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">www.economie.gouv.fr/mediation-conso</a>
        </p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">8. Conception du site</h2>
        <p className="text-muted-foreground font-body">
          Design et développement : <a href="https://b-to.io/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">B-TO</a>, agence digitale.
        </p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">9. Droit applicable</h2>
        <p className="text-muted-foreground font-body">Droit français. Tribunaux compétents : tribunaux français.</p>
      </div>
    </section>
  );
};

export default MentionsLegales;